// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"c67da25d","796":"7a3763ea"}[chunkId] + ".chunk.js";
};